<template>
<article>
  <section class="xbed-sub-title">
    <span>账号权限管理</span>
  </section>

  <section class="xbed-breadcrumb">
    <Breadcrumb>
      <BreadcrumbItem>管理员权限</BreadcrumbItem>
      <BreadcrumbItem>账号管理</BreadcrumbItem>
    </Breadcrumb>
  </section>
  <section style="margin-top: 20px">
    <Form inline :label-width="80" ref="userForm">
      <FormItem label="账号">
        <Input v-model="query.username"></Input>
      </FormItem>
      <FormItem label="手机号码">
        <Input v-model.trim="query.mobile"></Input>
      </FormItem>
      <FormItem label="群组">
        <Input v-model="query.groupName"></Input>
      </FormItem>
      <FormItem label="数据范围">
        <Input v-model="query.roomsRangeName"></Input>
      </FormItem>
      <FormItem :label-width="20">
        <Button type="primary" @click="getUserDataList">查询</Button>
      </FormItem>
      <FormItem :label-width="30">
        <Button type="primary" @click="openModal(null)">新建账号</Button>
      </FormItem>
    </Form>
    <Table stripe :columns="roleColumns" :data="data.list"></Table>
    <Page show-sizer :total="data.total" :page-size="query.pageSize" style="margin-top:10px;"
      @on-change="(page)=>{changePage(page,'role')}" @on-page-size-change="(size)=>{changePageSize(size,'role')}"
    ></Page>
  </section>
  <Modal :title="userForm.title" v-model="userForm.display" :loading="true" @on-ok="submitUser" ref="userModal">
    <Form :label-width="80" :model="userForm.data" :rules="userForm.rules" ref="userForm">
      <FormItem label="账号名" prop="username">
        <Input v-model="userForm.data.username"></Input>
      </FormItem>
      <FormItem label="手机号码" prop="mobile">
        <Input v-model="userForm.data.mobile" :maxlength='11'></Input>
      </FormItem>
      <FormItem label="密码" :prop="userForm.data.userId ? '' : 'password'">
        <Input type="password" v-model="userForm.data.password" :placeholder="userForm.data.userId ? '密码为空则不修改密码' : ''"></Input>
      </FormItem>
      <Row>
        <h3>权限群组</h3>
      </Row>
      <Row>
        <CheckboxGroup v-model="userForm.data.powerGroupIds">
          <Checkbox v-for="item in powerGroup" :key="item.id" :label="item.id">{{item.name}}</Checkbox>
        </CheckboxGroup>
      </Row>
    </Form>
    <Row slot='footer'>
      <Button @click="userForm.display=false">取消</Button>
      <Button type="primary" @click="submitUser">保存</Button>
      <Button type="primary" @click="submitUser('dataRange')">保存并设置数据</Button>
    </Row>
  </Modal>
  <Modal title="房间数据范围" v-model="rangeModal.display" @on-ok="submitRange">
    <Row class="row">
      <p>账号名：{{rangeModal.data.username}}</p>
    </Row>
    <Row class="row">
      <Checkbox v-model="isAllData">查看全部数据</Checkbox>
    </Row>
    <table class="table" cellspacing="0" cellpadding="0">
      <tr>
        <td>
          <p>查看城市</p>
          <Button size="small" type="primary" @click="addSelect('citys')">添加</Button>
        </td>
        <td>
          <Tag color="warning" closable v-for="(item, index) in rangeModal.data.roomsRange.citys" :key="item.id" @on-close="closeTag('citys',index)">{{item.name}}</Tag>
        </td>
      </tr>
      <tr>
        <td>
          <p>查看行政区</p>
          <Button size="small" type="primary" @click="addSelect('districts')">添加</Button>
        </td>
        <td>
          <Tag color="warning" closable v-for="(item, index) in rangeModal.data.roomsRange.districts" :key="item.id" @on-close="closeTag('districts',index)">{{item.name}}</Tag>
        </td>
      </tr>
      <tr>
        <td>
          <p>查看门店</p>
          <Button size="small" type="primary" @click="addSelect('chains')">添加</Button>
        </td>
        <td>
          <Tag color="warning" closable v-for="(item, index) in rangeModal.data.roomsRange.chains" :key="item.id" @on-close="closeTag('chains',index)">{{item.name}}</Tag>
        </td>
      </tr>
    </table>
  </Modal>
  <Modal title="添加城市" v-model="select.citys.isShow" ok-text="添加，下一个" :loading="true" @on-ok="addTag('citys')" ref="citys">
    <Select v-model="select.citys.value"
      label-in-value
      filterable
      remote
      :remote-method="(query)=>{romoteQuery('citys', query)}"
      :loading="select.citys.loading"
      @on-change="(option)=>{selectChange(option,'citys')}"
    >
      <Option v-for="option in select.citys.list" :key="option.id" :value="option.id">{{option.name}}</Option>
    </Select>
  </Modal>
  <Modal title="添加行政区" v-model="select.districts.isShow" ok-text="添加，下一个" :loading="true" @on-ok="addTag('districts')" ref="districts">
    <Select v-model="select.districts.value"
      label-in-value
      filterable
      remote
      :remote-method="(query)=>{romoteQuery('districts', query)}"
      :loading="select.districts.loading"
      @on-change="(option)=>{selectChange(option,'districts')}"
    >
      <Option v-for="option in select.districts.list" :key="option.id" :value="option.id">{{option.cityName}}-{{option.name}}</Option>
    </Select>
  </Modal>
  <Modal title="添加门店" v-model="select.chains.isShow" width="650px" @on-ok="addChains">
    <Form inline :label-width="60">
      <FormItem label="城市">
        <Select v-model="select.chains.city"
          filterable
          remote
          :remote-method="(query)=>{romoteQuery('citys', query)}"
          :loading="select.citys.loading"
        >
          <Option v-for="option in select.citys.list" :key="option.id" :value="option.name">{{option.name}}</Option>
        </Select>
      </FormItem>
      <FormItem label="门店">
        <Input v-model="select.chains.chainName" placeholder="输入id/门店名"></Input>
      </FormItem>
      <FormItem :label-width="20">
        <Button type="primary" @click="queryChains">查询</Button>
      </FormItem>
    </Form>
    <Table :columns="roomColumns" :data="select.chains.roomList"
      @on-select-all="selectAll" @on-select="selectRow" @on-select-cancel="cancelRow" @on-selection-change="selectAllCancel"
    ></Table>
    <Page show-sizer :total="select.chains.total" :page-size="select.chains.pageSize"
      @on-change="(page)=>{changePage(page,'room')}" @on-page-size-change="(size)=>{changePageSize(size,'room')}"
    ></Page>
  </Modal>
</article>
</template>

<script>
import Utils from '@/utils'
import API from '@/api'
import {phoneRegular} from "../../utils/regular"
export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  async mounted() {
    this.$Notice.config( {
			top: 200
    } );
    await this.getUserDataList()
    this.listAllGroups()
  },
  data() {
    return {
      openModalRowData: {}, // 存储临时的数据
      isAllData: false,
      query: {
        pageSize: 10,
        pageNum: 1,
        groupName: '',
        roomsRangeName: '',
        username: '',
        mobile:''
      },
      userForm: {
        display: false,
        title: '新建账号',
        data: {
          username: '',
          password: '',
          mobile:'',
          powerGroupIds: [],
          userId: null
        },
        rules: {
          username: [
            { required: true, message: '用户名不能为空', trigger: 'blur' }
          ],
          mobile: [
            { required: true, message: '手机号码不能为空', trigger: 'blur' },
            {pattern: phoneRegular, message: '格式不正确', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '密码不能为空', trigger: 'blur' },
          ],
        }
      },
      rangeModal: {
        display: false,
        data: {
          roomsRange: {},
          id: null,
          username: ''
        },
      },
      select: {
        citys:{
          isShow: false,
          loading: false,
          value: '',
          currentSelect: {},
          list: []
        },
        chains:{
          isShow: false,
          loading: false,
          chainName: '',
          city: '',
          page: 1,
          pageSize: 10,
          total: 0,
          roomList: [],
          selectIds: [],
          selectRoom: [],
        },
        districts:{
          isShow: false,
          loading: false,
          value: '',
          currentSelect: {},
          list: []
        },
      },
      powerGroup: [],
      data: {},
      roleColumns: [
        {
          title: 'ID',
          width: 100,
          align: 'center',
          key: 'id'
        },
        {
          title: '账号名称',
          width: 150,
          align: 'center',
          key: 'username'
        },
        {
          title: '手机号码',
          width: 150,
          align: 'center',
          key: 'mobile'
        },
        {
          title: '权限群组',
          width: 300,
          align: "center",
          render: (h, params) => {
            const group = params.row.groups;
            let tagArr = [];
            group.forEach(item => {
              tagArr.push(h('Tag', {
                props:{
                  color: 'blue'
                }
              }, item.name))
            });
            return h('div',{}, tagArr)
          }
        },
        {
          title: '房间数据范围',
          width: 450,
          // align: 'center',
          render: (h, params) => {
            const citys = params.row.roomsRange.citys;
            const chains = params.row.roomsRange.chains;
            const districts = params.row.roomsRange.districts;
            let cityTags = this.containTagList(h, citys);
            let chainTags = this.containTagList(h, chains);
            let districtsTags = this.containTagList(h, districts);
            return h('div', [
              h('Row', [
                h('Col', {
                  props: {
                    span: 4
                  },
                  style: {
                    textAlign: 'left'
                  }
                }, '城市:'),
                h('Col', {
                  props: {
                    span: 20
                  },
                  style: {
                    textAlign: 'left'
                  }
                }, cityTags.length==0?'无':cityTags),
              ]),
              h('Row', [
                h('Col', {
                  props: {
                    span: 4
                  },
                  style: {
                    textAlign: 'left'
                  }
                }, '行政区:'),
                h('Col', {
                  props: {
                    span: 20
                  },
                  style: {
                    textAlign: 'left'
                  }
                }, districtsTags.length==0?'无':districtsTags),
              ]),
              h('Row', [
                h('Col', {
                  props: {
                    span: 4
                  },
                  style: {
                    textAlign: 'left'
                  }
                }, '门店:'),
                h('Col', {
                  props: {
                    span: 20
                  },
                  style: {
                    textAlign: 'left'
                  }
                }, chainTags.length==0?'无':chainTags),
              ]),
            ])
          }
        },
        {
          title: '操作',
          width: 250,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.openModal(params.row)
                  }
                }
              }, '基本信息'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginLeft: '5px'
                },
                on: {
                  click: () => {
                    this.openRoomRage(params.row)
                  }
                }
              }, '数据范围'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                style: {
                  marginLeft: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '消息提示？',
                      content: '确定删除该账号吗？',
                      okText:'确定',
                      cancelText:'取消',
                      onOk: () => {
                        this.deleteUser(params.row.id)
                      }
                    })
                  }
                }
              }, '删除')
            ])
          }
        },
      ],
      roomColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: 'id',
          width: 80,
          align: 'center',
          key: 'chainId'
        },
        {
          title: '门店名',
          align: 'center',
          key: 'chainName'
        },
        {
          title: '省市区',
          align: 'center',
          render: (h, params) => {
            return h('span', `${params.row.province}-${params.row.district}-${params.row.city}`)
          }
        },
      ]
    }
  },
  methods: {
    changePage(page, type) {
      if(type === 'room') {
        this.select.chains.page = page
        this.queryChains()
      }else if(type === 'role'){
        this.query.pageNum = page
        this.getUserDataList()
      }
    },
    changePageSize(size, type) {
      if(type === 'room') {
        this.select.chains.page = 1
        this.select.chains.pageSize = size
        this.queryChains()
      }else if(type === 'role'){
        this.query.pageNum = 1
        this.query.pageSize = size
        this.getUserDataList()
      }
    },
    openModal(obj) {
      this.openModalRowData = obj;
      this.$refs.userForm.resetFields();
      this.userForm.display = true;
      this.userForm.data.powerGroupIds = [];
      this.userForm.data.username = '';
      this.userForm.data.mobile = '';
      this.userForm.data.password = '';
      this.userForm.data.userId = null;
      if(obj) {
        this.userForm.title = "编辑账号";
        this.userForm.data.username = obj.username;
        this.userForm.data.password = "888888";
        this.userForm.data.mobile = obj.mobile
        this.userForm.data.userId = obj.id;
        obj.groups.forEach(item => {
          this.userForm.data.powerGroupIds.push(Number(item.id))
        })
      }
    },
    async openRoomRage(obj) {
      let res = await this.listRangeByUserId(obj.id)
      this.rangeModal.display = true;
      this.isAllData = res.hasAll == 1;
      this.rangeModal.data.roomsRange = JSON.parse(JSON.stringify(obj.roomsRange))
      this.rangeModal.data.username = obj.username
      this.rangeModal.data.id = obj.id
    },
    submitUser(redirectTo) {
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          const userInfo = Object.assign({}, this.userForm.data);
          if(userInfo.userId) {
            // edit
            this.editUser(userInfo, redirectTo)
          } else {
            // add
            this.addUser(userInfo, redirectTo)
          }
        } else {
          this.$refs.userModal.buttonLoading = false
        }
      })
    },
    closeTag(type, index) {
      this.rangeModal.data.roomsRange[type].splice(index,1)
    },
    addSelect(type) {
      this.select[type].value = '';
      this.select[type].isShow = true;
      this.romoteQuery(type, '')
      if(type === 'chains') {
        this.select.chains.selectIds = [];
        this.select.chains.selectRoom = [];
        this.select.chains.roomList = [];
        this.select.chains.city = '';
        this.select.chains.chainName = '';
        this.rangeModal.data.roomsRange.chains.forEach(item => {
          this.select.chains.selectIds.push(Number(item.name.split('_')[0]))
          this.select.chains.selectRoom.push({
            chainId: Number(item.name.split('_')[0]),
            chainName: item.name.split('_')[1]
          })
        })
      }else {
        this.select[type].currentSelect = {},
        this.select[type].list = []
      }
    },
    selectChange(option, type) {
      this.select[type].currentSelect = {
        value: option.value,
        label: option.label
      }
    },
    addTag(type) {
      this.$refs[type].buttonLoading = false;
      if(this.rangeModal.data.roomsRange[type].filter(item=>{
        return item.name === this.select[type].currentSelect.label
      }).length>0){
        this.$Notice.error({
          title: '已存在，无需重复添加'
        })
      }else{
        this.select[type].currentSelect.value && (
          this.rangeModal.data.roomsRange[type].push({
            id: this.select[type].currentSelect.value,
            name: this.select[type].currentSelect.label
          })
        )
      }
      this.select[type].value = ""
    },
    addChains() {
      this.rangeModal.data.roomsRange.chains = [];
      this.select.chains.selectRoom.forEach(item => {
        this.rangeModal.data.roomsRange.chains.push({
          name: `${item.chainId}_${item.chainName}`
        })
      })
    },
    romoteQuery(type, keyword) {
      // if(keyword !== '') {
        this.select[type].loading = true;
        switch (type) {
          case 'citys':
            this.queryCity(type, keyword)
            break;
          // case 'chains':
          //   this.queryChains(type, keyword)
          //   break;
          case 'districts':
            this.queryDistricts(type, keyword)
            break;
        }
      // }
    },
    /**
     * table中数据支持多选
     * 当选中数据后切换页记录已选数据不丢失
     */
    // 当前列表取消全选
    selectAllCancel(selection) {
      if(selection.length===0) {
        this.select.chains.roomList.forEach((item)=>{
          let index = this.select.chains.selectIds.indexOf(item.chainId);
          if(index !== -1){
            this.select.chains.selectIds.splice(index,1);
            this.select.chains.selectRoom.splice(index,1);
          }
        })
      }
    },
    // 当前列表全选
    selectAll(selection) {
      if(selection.length!==0){
        selection.forEach((item)=>{
          if(!this.select.chains.selectIds.includes(item.chainId)){
            this.select.chains.selectIds.push(item.chainId);
            this.select.chains.selectRoom.push(item);
          }
        })
      }
    },
    //列表单选
    selectRow(selection, row) {
      this.select.chains.selectIds.push(row.chainId);
      this.select.chains.selectRoom.push(row);
    },
    //列表取消单选
    cancelRow(selection, row){
      let index = this.select.chains.selectIds.indexOf(row.chainId);
      this.select.chains.selectIds.splice(index, 1);
      this.select.chains.selectRoom.splice(index, 1);
    },
    submitRange() {
      let rangeArr = [];
      this.rangeModal.data.roomsRange.citys.forEach(item => {
        rangeArr.push({
          name: item.name,
          type: 1,
          userId: this.rangeModal.data.id,
          value: item.name
        })
      });
      this.rangeModal.data.roomsRange.districts.forEach(item => {
        rangeArr.push({
          name: item.name,
          type: 2,
          userId: this.rangeModal.data.id,
          value: item.name.split('-')[1]
        })
      });
      this.rangeModal.data.roomsRange.chains.forEach(item => {
        rangeArr.push({
          name: item.name,
          type: 3,
          userId: this.rangeModal.data.id,
          value: item.name.split('_')[0]
        })
      })
      this.addOmsUserRoomsRange(rangeArr)
    },
    async listAllGroups() {
      let resp = (await API.omsAPI[this.env].system.listAllGroups(this.token)).data
      this.powerGroup = resp
    },
    async queryCity(type,keyword) {  //匹配查询城市
      let resp = (await API.omsAPI[this.env].system.getDistrictCities({
        sort: "",
        provinceId: "",
        page: 1,
        orderBy: "",
        isHotCity: "",
        search: keyword,
        rows: 9999
      }, this.token)).data;
      this.select[type].loading = false
      this.select[type].list = resp.result;
    },
    async queryChains () {  // 获取房间列表
      let resp = (await API.omsAPI[this.env].system.searchChain(
        {
          pageNum: this.select.chains.page,
          pageSize: this.select.chains.pageSize,
          chainName: this.select.chains.chainName,
          city: this.select.chains.city,
        },
        this.token
      )).data
      this.select.chains.roomList = resp.list;
      this.select.chains.roomList.forEach((item)=> {
        if(this.select.chains.selectIds.includes(item.chainId)) {
          item._checked = true;
        }
      })
      this.select.chains.total = resp.total;
    },
    async queryDistricts (type, keyword) {  //匹配查询地区
      let resp = (await API.omsAPI[this.env].system.getDistrictCounties({
        sort: "",
        provinceId: "",
        page: 1,
        orderBy: "",
        isHotCity: "",
        search: keyword,
        rows: 9999
      }, this.token)).data;
      this.select[type].loading = false
      this.select[type].list = resp.result;
    },
    async getUserDataList() { // 获取账号数据列表
      let params = Object.assign({}, this.query);
      Object.keys(params).forEach(item => {
        if(!params[item]) delete params[item]
      })
      let resp = (await API.omsAPI[this.env].system.getUserDataList(params, this.token)).data
      if(resp.retCode) {
        this.$Notice.error({
          title: '获取数据失败',
          desc: resp.msg
        })
      }
      this.data = resp
    },
    async addUser(user, redirectTo) { // 添加用户
      const reg = /^.*(?=.{8,20})(?=.*\d)(?=.*[a-zA-Z])(?=.*[-!@#$^*()~~./,<>:;\{}|?])(?!.*[%&_+=\[\]])(?!.*Xbed)(?!.*201[5,6,7])/
      if(!reg.test(user.password)) {
        this.$Notice.error({
          title: '密码格式有误',
          desc: '新密码必须在8～20位，必须包含数字+字母+特殊字符(例如：`~!@#$^*()-./?,<>;:\'{}|)，且不能含有%&_+=[]"、Xbed、2015、2016、2017等关键字'
        })
        this.$refs.userModal.buttonLoading = false;
        return
      }
      let resp = (await API.omsAPI[this.env].system.addUser(
       {
        groupIds:user.powerGroupIds.join(','),
        password:user.password,
        username:user.username,
        mobile:user.mobile,
       },
        this.token
      )).data
      this.userForm.display = false
      if(resp.retCode) {
        this.$Notice.error({
          title: '添加失败',
          desc: resp.msg
        })
        return
      }
      if(redirectTo === 'dataRange'){
        this.openRoomRage({
          id: resp.id,
          username: resp.username,
          groups: [],
          roomsRange:{
            districts: [],
            chains: [],
            citys: []
          }
        })
      }
      this.$Notice.success({
        title: '添加成功'
      })
      this.getUserDataList()
    },
    async editUser(user, redirectTo) { // 编辑用户
      if((user.password !== "") && (user.password !== "888888")) {
        const reg = /^.*(?=.{8,20})(?=.*\d)(?=.*[a-zA-Z])(?=.*[-!@#$^*()~~./,<>:;\{}|?])(?!.*[%&_+=\[\]])(?!.*Xbed)(?!.*201[5,6,7])/
        if(!reg.test(user.password)) {
          this.$Notice.error({
            title: '密码格式有误',
            desc: '新密码必须在8～20位，必须包含数字+字母+特殊字符(例如：`~!@#$^*()-./?,<>;:\'{}|)，且不能含有%&_+=[]"、Xbed、2015、2016、2017等关键字'
          })
          this.$refs.userModal.buttonLoading = false;
          return
        }
      }
      let resp = (await API.omsAPI[this.env].system.editUser(
        {
          groupIds: user.powerGroupIds.join(','),
          id: user.userId,
          password: user.password=="888888" ? "" : user.password,
          username: user.username,
          mobile:user.mobile
        },
        this.token
      )).data
      this.userForm.display = false
      if(resp.retCode) {
        this.$Notice.error({
          title: '更新失败',
          desc: resp.msg
        })
        return
      }
      if(redirectTo === 'dataRange'){
        this.openRoomRage(this.openModalRowData)
      }
      this.$Notice.success({
        title: '更新成功'
      })
      this.getUserDataList()
    },
    async deleteUser(userId) { // 删除用户
      let resp = (await API.omsAPI[this.env].system.deleteUser(userId, this.token)).data;
      if(resp.retCode) {
        this.$Notice.error({
          title: '删除失败',
          desc: resp.msg
        })
        return
      }
      this.$Notice.success({
        title: '删除成功'
      })
      this.getUserDataList()
    },
    async addOmsUserRoomsRange(rangeArr) { // 添加用户房间数据范围
      let resp = (await API.omsAPI[this.env].system.addOmsUserRoomsRange(
        {
          omsNewRoomsRangeList: JSON.stringify(rangeArr),
          isAll: this.isAllData ? 1 : 2,
          userId: this.rangeModal.data.id
        },
        this.token
      )).data
      if(resp.retCode) {
        this.$Notice.error({
          title: '更新失败',
          desc: resp.msg
        })
      } else {
        this.$Notice.success({
          title: '更新成功'
        })
        this.getUserDataList()
      }
    },
    async deleteAllUserRoomsRange(userId) { // 删除用户房间数据范围
      let resp = (await API.omsAPI[this.env].system.deleteAllUserRoomsRange(userId, this.token)).data
      return resp.retCode ? {} : resp
    },
    async listRangeByUserId(userId) { // 获取用户房间数据范围
      let resp = (await API.omsAPI[this.env].system.listRangeByUserId(userId, this.token)).data;
      return resp.retCode? {} : resp
    },
    containTagList(h, group){
      let arr = [];
      group.forEach(item => {
        arr.push(h('Tag', {
          props: {
            color: 'blue'
          }
        }, item.name))
      });
      return arr
    }
  }
}
</script>

<style lang="scss" scoped>
.row{
  margin: 10px 0;
}
.table{
  width: 100%;
  table-layout: fixed;
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #ddd;
  tr td:first-child{
    width: 85px;
    text-align: center
  }
  td {
    border-left: 1px solid #ddd;
    border-top: 1px solid #ddd;
    text-align: left;
    padding: 5px
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/system/role-manage.vue